import {createAction} from "redux-act";

export const fetchDashboard = createAction();

interface IDashboard {
	currentStreak: number | null;
	bestStreak: number | null;
	rank: number | null;
	isTied: number | null;
	accuracy: number | null;
	percentile: number | null;
	nextStreakGoal: number | null;
	isMulliganUsed: boolean;
	isMulliganCanBeUsed: boolean;
	isMulliganAllowed: boolean;
	isMulliganEnabled: boolean;
	numberPredictions: number;
	numberFriendsEntries: number;
}

export const fetchDashboardSuccess = createAction<IDashboard>();
export const fetchDashboardFailed = createAction();
